@if (isActive()) {
    <form class="inner-page-wrapper pb-24 pt-16" [formGroup]="form">
        @if (servicesFormContent(); as serviceForm) {
            <div class="mb-24 md:mb-40">
                <h1 class="text-31 leading-36 md:text-center md:text-50 md:leading-58">Service-Termin vereinbaren</h1>
                <h2 class="text-16 leading-27 md:mt-4 md:text-center md:text-22 md:leading-28">Leistungen wählen</h2>
            </div>

            @if (featuredService(); as service) {
                <div class="relative mx-auto mb-24 max-w-[744px] border-2 border-black bg-grey-100 px-12 py-16">
                    @if (service.price) {
                        @let servicePrice = service.price | footnotes;
                        <div class="absolute right-0 top-0 flex h-32 items-center bg-white px-12 md:h-[27px]">
                            <span
                                class="font-headline text-12 font-medium md:text-16 md:leading-27"
                                [innerHTML]="servicePrice()"
                            ></span>
                        </div>
                    }
                    <div class="mb-16 flex gap-8">
                        @for (
                            campaignService of form.controls.afterSalesServices.controls;
                            track campaignService.value
                        ) {
                            @if (campaignService.controls.identifier.value === featuredServiceId()) {
                                <ui-input-checkbox
                                    [formControl]="campaignService.controls.selected"
                                    (trackCheckbox)="trackCheckbox()"
                                >
                                    <span
                                        class="md:tracking-28 cursor-pointer font-headline text-16 font-medium leading-27 md:text-22"
                                        [innerHTML]="service.label"
                                    ></span>
                                </ui-input-checkbox>
                            }
                        }
                    </div>
                    <p class="leading-21 text-14">
                        {{ readMore() ? service.longDescription : service.shortDescription }}
                    </p>
                    @if (service.longDescription) {
                        <button
                            class="leading-21 mt-[18px] flex items-center justify-center text-14 text-accent"
                            (click)="readMore.set(!readMore())"
                        >
                            <span>{{ readMore() ? 'Weniger anzeigen' : 'Mehr anzeigen' }}</span>
                            <i
                                class="icon-chevron-down p-8 text-10 transition-all"
                                [ngClass]="{
                                    'rotate-180': readMore(),
                                }"
                            ></i>
                        </button>
                    }
                </div>
            }

            @if (serviceForm.campaign.afterSalesServices && serviceForm.campaign.afterSalesServices.length > 0) {
                <div class="mx-auto max-w-[744px] bg-grey-100 px-24 pb-16 pt-12 md:bg-grey-500">
                    <h3 class="mb-16 text-16 leading-27 md:text-22 md:leading-28">
                        {{ serviceForm.campaign.minimumshortTitle }}
                    </h3>
                    <div class="grid grid-cols-1 gap-x-56 gap-y-16 md:grid-cols-2">
                        @for (
                            campaignService of form.controls.afterSalesServices.controls;
                            track campaignService.value;
                            let i = $index
                        ) {
                            @let teaserLabel = campaignService.controls.name.value | footnotes;
                            @if (campaignService.controls.identifier.value !== featuredServiceId()) {
                                <ui-input-checkbox
                                    [formControl]="campaignService.controls.selected"
                                    (trackCheckbox)="trackCheckbox()"
                                >
                                    <span [innerHTML]="teaserLabel()"></span>
                                </ui-input-checkbox>
                            }
                        }
                    </div>
                </div>
            }

            <div class="mx-auto max-w-[744px] px-24 pb-40 pt-16">
                @if (serviceForm.generalServices && serviceForm.generalServices.length > 0) {
                    <div class="grid grid-cols-1 gap-x-56 gap-y-16 md:grid-cols-2">
                        @for (
                            teaser of form.controls.generalServices.controls | serviceFormSorter;
                            track teaser.value
                        ) {
                            @if ($index < 6 || showAllServices()) {
                                @let teaserLabel = teaser.controls.name.value | footnotes;
                                <ui-input-checkbox
                                    [formControl]="teaser.controls.selected"
                                    (trackCheckbox)="trackCheckbox()"
                                >
                                    <span [innerHTML]="teaserLabel()"></span>
                                </ui-input-checkbox>
                            }
                        }
                    </div>
                }
                @if (serviceForm.generalServices.length > 6) {
                    <div class="mt-16 flex justify-center">
                        <button (click)="showAll()">
                            {{ showAllServices() ? 'Weniger anzeigen' : 'Alle anzeigen' }}
                        </button>
                    </div>
                }
                <div class="my-24 border-b-1 border-grey-200"></div>
                <div class="flex flex-col justify-between gap-40 md:flex-row md:gap-24">
                    <div>
                        <ui-m020-c070-input-toggle
                            [label]="'Ersatzfahrzeuge anfragen'"
                            [control]="form.controls.replacementVehicle"
                        />
                    </div>
                    <button class="button-primary w-auto" (click)="next()">Weiter - nur noch eine Seite</button>
                </div>
            </div>
        }
    </form>
}
